export enum ConversationRoutes {
  root = 'conversations',
  calls = 'calls',
  search = 'search',
  profile = 'profile',
}
